import classNames from 'classnames';
import React, { useMemo } from 'react';
import RadioGroupItem from './RadioGroupItem';
const isRadioGroupItemComponent = (c) => {
    let isRadioGroup = !!c.props && c.props.__TYPE === 'RadioGroupItem';
    if (!isRadioGroup) {
        // console.warn('Element is not an RadioGroup item. Type name:' + c.type?.name + ' - element ', c);
        return false;
    }
    return true;
};
const RadioGroup = (props) => {
    const radioGroupItems = useMemo(() => props.children.filter((c) => isRadioGroupItemComponent(c)), [props.children]);
    const printItems = () => {
        return radioGroupItems.map((c, i) => (React.createElement(RadioGroupItem, Object.assign({ selected: c.props.selected, setSelected: props.setSelected, groupId: props.id, key: i }, c.props), c.props.children)));
    };
    return (React.createElement("div", { className: classNames('optionbox', props.type != '' ? `optionbox--${props.type}` : null, props.className), "aria-labelledby": props.labelId }, radioGroupItems.length > 0 ? printItems() : props.children));
};
RadioGroup.defaultProps = {
    type: '',
};
export default RadioGroup;
